import type { TranslationModule } from '../types';

export const abonamenteTranslations: TranslationModule = {
  ro: {
    seo: {
      title: "Abonamente LegeaAplicata - Juridic AI Advanced și Cont",
      desc: "Alege abonamentul potrivit pentru acces la funcții juridice AI avansate. Conturi pentru studenți, profesioniști și instituții. Deblochează analiza predictivă și căutarea nelimitată.",
      keywords: "juridice cont, juridice ai abonament, juridice ai student, juridice ai advanced, abonament legea aplicata, preturi juridice ai, cont avocat, cont jurisconsult, pachete servicii juridice",
      productName: "LegeaAplicata.ro Juridic AI",
      productDesc: "Platformă avansată de cercetare juridică și analiză AI pentru profesioniștii din domeniul juridic din România.",
      offerBasicDesc: "Acces limitat pentru vizitatori",
      offerPremiumDesc: "Acces complet la funcții AI"
    },
    badgePopular: "RECOMANDAT",
    priceAfterRegister: "Prețul este disponibil după înregistrare",
    billed: "Facturat",
    slotsRemaining: "rămase",
    details: "Detalii",
    backBtn: "Înapoi la Pagina Principală",
    faqTitle: "Întrebări Frecvente",
    intervals: {
      month: "lună",
      sixMonths: "6 luni",
      year: "an",
      unlimited: "Nelimitat"
    },
    billingFrequency: {
      monthly: "lunar",
      sixMonths: "la 6 luni",
      yearly: "anual"
    },
    cta: {
      promoFree: "Începe gratuit acum",
      basic: "Creează Cont Gratuit",
      premium_monthly: "Abonează-te Acum",
      premium_semiannual: "Abonează-te Acum",
      premium_annual: "Abonează-te Acum"
    },
    promoBannerText1: "Primii {limit} de utilizatori au acces",
    promoBannerText2: "GRATUIT la Premium.",
    promoLimitedOffer: "Oferta este limitată – profită acum!",
    bottomPromoBannerTitle: "Doar pentru primii {limit}.",
    bottomPromoBannerDesc: "După atingerea limitei, abonamentul va fi disponibil la prețul standard.",
    featuresIncludePrevious: "Tot ce include {previousPlan}, plus:",
    featuresIncludeThis: "Acest plan include:",
    audioDaily: "Audio Legislație — {count} de interogări pe zi",
    audioUnlimited: "Audio Legislație — interogări nelimitate",
    personalAudio: "Seturi personale cu redare audio",
    personalAudioDetails: "20 de seturi × 100 de întrebări. Categorii proprii, grile cu 3 variante, barem și comentarii. Audio generat la salvare, regenerat la editare și șters odată cu grila.",
    studyGoals: "Obiective și statistici de studiu",
    studyGoalsDetails: "Țintă zilnică, dată de examen și progres pe 7, 30 sau 90 de zile. Răspunsuri corecte și încercări asistate.",
    audioDetails: "Un articol cu explicația AI inclusă = o interogare. Viteză reglabilă, semne de carte și temporizator. Pauza și reluarea nu consumă interogări.",
    checkout: {
      title: "Finalizare Plată",
      cancel: "Anulează"
    },
    promoSuccess: {
      title: "Felicitări! Contul tău este Premium.",
      desc: "Ai revendicat cu succes unul dintre locurile gratuite din campania noastră promoțională. Ai acces gratuit timp de 1 an la toate funcționalitățile platformei LegeaAplicată.",
      btn: "Începe Căutarea"
    },
    faqs: {
      q1: {
        question: "Cum funcționează abonamentele?",
        answer: "Abonamentele LegeaAplicata.ro oferă acces diferențiat la resursele juridice și funcționalitățile AI. Planul Gratuit permite explorarea de bază și căutarea în jurisprudență și legislație, în timp ce planurile Pro includ monitorizarea dosarelor de instanță cu alerte automate, alertele personalizate pentru modificări legislative cu notificări pe email, analize avansate și asistentul AI."
      },
      q2: {
        question: "Pot anula oricând?",
        answer: "Da, puteți anula abonamentul oricând din contul dumneavoastră. Accesul va rămâne valabil până la sfârșitul perioadei deja achitate."
      },
      q3: {
        question: "Există planuri pentru studenți?",
        answer: "Da, oferim reduceri speciale pentru studenți. Vă rugăm să ne contactați cu o dovadă a calității de student pentru a primi oferta."
      },
      q4: {
        question: "Sunt datele mele în siguranță?",
        answer: "Absolut. Folosim standarde de securitate industriale pentru a proteja toate datele și tranzacțiile. Plățile sunt procesate securizat prin Stripe."
      },
      q5: {
        question: "Primesc factură fiscală?",
        answer: "Da, pentru fiecare plată se emite automat factură fiscală care poate fi descărcată din contul de client sau de pe email."
      }
    },
    plans: {
      basic: {
        name: "Basic - Gratuit",
        cta: "Creează Cont Gratuit",
        features: {
          "0": {
            name: "Înregistrare gratuită",
            details: "Cont valabil permanent"
          },
          "1": {
            name: "Căutare în jurisprudență",
            details: "Acces la baza de date"
          },
          "2": {
            name: "Vizualizări limitate",
            details: "Max 20 rezultate per interogare"
          },
          "3": {
            name: "Profil personalizat",
            details: "Date personale securizate"
          },
          "4": {
            name: "Salvare rezultate",
            details: "Dosar virtual pentru spețe favorite"
          },
          "5": {
            name: "Statistici utilizare",
            details: "Monitorizare activitate"
          },
          "6": {
            name: "Generare Prompt Juridic Inteligent",
            details: "Redactare asistată de AI pentru dosare"
          },
          "7": {
            name: "Acces la cele 45 de funcții & calculatoare",
            details: "Ghid interactiv complet și unelte specializate"
          }
        }
      },
      premium_monthly: {
        name: "Premium - Lunar",
        cta: "Abonează-te Acum",
        features: {
          "0": {
            name: "Toate beneficiile Basic",
            details: null
          },
          "1": {
            name: "Căutare extinsă în jurisprudență",
            details: "Max 50 rezultate per interogare"
          },
          "2": {
            name: "Raport Juridic Predictiv (beta)",
            details: "Rată succes, durată estimată & strategii"
          },
          "3": {
            name: "Teste Grilă",
            details: "Generate automat din jurisprudență"
          },
          "4": {
            name: "Calculator Taxă de Timbru",
            details: "Calcul automat cu asistent AI"
          },
          "5": {
            name: "Indicatori & Concluzii Financiare",
            details: "Analiză automată contabilă"
          },
          "6": {
            name: "Suport prioritar",
            details: "Asistență dedicată"
          },
          "7": {
            name: "Generare Prompt Juridic Inteligent",
            details: "Redactare asistată de AI pentru dosare"
          },
          "8": {
            name: "Dosare Urmărite & Alerte la Modificări",
            details: "Monitorizare automată a dosarelor din instanță și notificări la termene noi, schimbări de stadiu, căi de atac și soluții."
          },
          "9": {
            name: "Modificări Legislative & Alerte Email",
            details: "Alerte personalizate pentru domeniile juridice urmărite și notificări email pentru modificările actelor normative monitorizate."
          }
        }
      },
      premium_semiannual: {
        name: "Premium - 6 Luni",
        cta: "Abonează-te Acum",
        features: {
          "0": {
            name: "Toate beneficiile Basic",
            details: null
          },
          "1": {
            name: "Căutare extinsă în jurisprudență",
            details: "Max 50 rezultate per interogare"
          },
          "2": {
            name: "Raport Juridic Predictiv (beta)",
            details: "Rată succes, durată estimată & strategii"
          },
          "3": {
            name: "Teste Grilă",
            details: "Generate automat din jurisprudență"
          },
          "4": {
            name: "Calculator Taxă de Timbru",
            details: "Calcul automat cu asistent AI"
          },
          "5": {
            name: "Indicatori & Concluzii Financiare",
            details: "Analiză automată contabilă"
          },
          "6": {
            name: "Suport prioritar",
            details: "Asistență dedicată"
          },
          "7": {
            name: "Generare Prompt Juridic Inteligent",
            details: "Redactare asistată de AI pentru dosare"
          },
          "8": {
            name: "Dosare Urmărite & Alerte la Modificări",
            details: "Monitorizare automată a dosarelor din instanță și notificări la termene noi, schimbări de stadiu, căi de atac și soluții."
          },
          "9": {
            name: "Modificări Legislative & Alerte Email",
            details: "Alerte personalizate pentru domeniile juridice urmărite și notificări email pentru modificările actelor normative monitorizate."
          }
        }
      },
      premium_annual: {
        name: "Premium - Anual",
        cta: "Abonează-te Acum",
        features: {
          "0": {
            name: "Toate beneficiile Basic",
            details: null
          },
          "1": {
            name: "Căutare extinsă în jurisprudență",
            details: "Max 50 rezultate per interogare"
          },
          "2": {
            name: "Raport Juridic Predictiv (beta)",
            details: "Rată succes, durată estimată & strategii"
          },
          "3": {
            name: "Teste Grilă",
            details: "Generate automat din jurisprudență"
          },
          "4": {
            name: "Calculator Taxă de Timbru",
            details: "Calcul automat cu asistent AI"
          },
          "5": {
            name: "Indicatori & Concluzii Financiare",
            details: "Analiză automată contabilă"
          },
          "6": {
            name: "Suport prioritar",
            details: "Asistență dedicată"
          },
          "7": {
            name: "Generare Prompt Juridic Inteligent",
            details: "Redactare asistată de AI pentru dosare"
          },
          "8": {
            name: "Dosare Urmărite & Alerte la Modificări",
            details: "Monitorizare automată a dosarelor din instanță și notificări la termene noi, schimbări de stadiu, căi de atac și soluții."
          },
          "9": {
            name: "Modificări Legislative & Alerte Email",
            details: "Alerte personalizate pentru domeniile juridice urmărite și notificări email pentru modificările actelor normative monitorizate."
          }
        }
      }
    }
  },
  en: {
    seo: {
      title: "LegeaAplicata Subscriptions - Advanced Legal AI and Accounts",
      desc: "Choose the right subscription for access to advanced legal AI features. Accounts for students, professionals, and institutions. Unlock predictive analysis and unlimited search.",
      keywords: "legal account, legal ai subscription, legal ai student, legal ai advanced, subscription legea aplicata, pricing legal ai, lawyer account, legal advisor account, legal packages",
      productName: "LegeaAplicata.ro Legal AI",
      productDesc: "Advanced legal research and AI analysis platform for legal professionals in Romania.",
      offerBasicDesc: "Limited access for visitors",
      offerPremiumDesc: "Complete access to AI features"
    },
    badgePopular: "RECOMMENDED",
    priceAfterRegister: "Price is available after registration",
    billed: "Billed",
    slotsRemaining: "remaining",
    details: "Details",
    backBtn: "Back to Home Page",
    faqTitle: "Frequently Asked Questions",
    intervals: {
      month: "month",
      sixMonths: "6 months",
      year: "year",
      unlimited: "Unlimited"
    },
    billingFrequency: {
      monthly: "monthly",
      sixMonths: "every 6 months",
      yearly: "annually"
    },
    cta: {
      promoFree: "Start free now",
      basic: "Create Free Account",
      premium_monthly: "Subscribe Now",
      premium_semiannual: "Subscribe Now",
      premium_annual: "Subscribe Now"
    },
    promoBannerText1: "The first {limit} users get",
    promoBannerText2: "FREE access to Premium.",
    promoLimitedOffer: "Offer is limited – claim now!",
    bottomPromoBannerTitle: "Only for the first {limit}.",
    bottomPromoBannerDesc: "After reaching the limit, the subscription will be available at standard pricing.",
    featuresIncludePrevious: "Everything included in {previousPlan}, plus:",
    featuresIncludeThis: "This plan includes:",
    audioDaily: "Audio Legislation — {count} requests per day",
    audioUnlimited: "Audio Legislation — unlimited requests",
    personalAudio: "Personal sets with audio playback",
    personalAudioDetails: "20 sets × 100 questions. Custom categories, three-choice questions, answer keys and comments. Audio is generated on save, regenerated on edits and deleted with the question.",
    studyGoals: "Study goals and statistics",
    studyGoalsDetails: "Daily target, exam date and progress over 7, 30 or 90 days. Correct answers and assisted attempts.",
    audioDetails: "One article with its AI explanation = one request. Adjustable speed, bookmarks and sleep timer. Pausing and resuming use no additional requests.",
    checkout: {
      title: "Checkout",
      cancel: "Cancel"
    },
    promoSuccess: {
      title: "Congratulations! Your account is Premium.",
      desc: "You have successfully claimed one of the free spots in our promotional campaign. You have free access for 1 year to all features of the LegeaAplicată platform.",
      btn: "Start Searching"
    },
    faqs: {
      q1: {
        question: "How do subscriptions work?",
        answer: "LegeaAplicata.ro subscriptions offer tiered access to legal resources and AI features. The Free plan allows basic exploration, while Premium plans unlock advanced analysis, the AI assistant, and unlimited access to case law."
      },
      q2: {
        question: "Can I cancel anytime?",
        answer: "Yes, you can cancel your subscription at any time from your account settings. Access will remain valid until the end of the already paid period."
      },
      q3: {
        question: "Are there plans for students?",
        answer: "Yes, we offer special discounts for students. Please contact us with proof of student status to receive the offer."
      },
      q4: {
        question: "Is my data safe?",
        answer: "Absolutely. We use industry-standard security measures to protect all data and transactions. Payments are processed securely via Stripe."
      },
      q5: {
        question: "Do I receive an invoice?",
        answer: "Yes, a tax invoice is automatically issued for each payment, which can be downloaded from your client account or received by email."
      }
    },
    plans: {
      basic: {
        name: "Basic - Free",
        cta: "Create Free Account",
        features: {
          "0": {
            name: "Free registration",
            details: "Permanently valid account"
          },
          "1": {
            name: "Case law search",
            details: "Access to the database"
          },
          "2": {
            name: "Limited views",
            details: "Max 20 results per query"
          },
          "3": {
            name: "Customized profile",
            details: "Secure personal data"
          },
          "4": {
            name: "Save results",
            details: "Virtual folder for favorite cases"
          },
          "5": {
            name: "Usage statistics",
            details: "Activity monitoring"
          },
          "6": {
            name: "Smart Legal Prompt Generation",
            details: "AI-assisted drafting for cases"
          },
          "7": {
            name: "Access to all 45 tools & calculators",
            details: "Complete interactive guide and specialized legal tools"
          }
        }
      },
      premium_monthly: {
        name: "Premium - Monthly",
        cta: "Subscribe Now",
        features: {
          "0": {
            name: "All Basic benefits",
            details: null
          },
          "1": {
            name: "Extended jurisprudence search",
            details: "Max 50 results per query"
          },
          "2": {
            name: "Predictive Legal Report (beta)",
            details: "Success rate, estimated duration & strategies"
          },
          "3": {
            name: "Grid Tests",
            details: "Automatically generated from case law"
          },
          "4": {
            name: "Stamp Duty Calculator",
            details: "Automatic calculation with AI assistant"
          },
          "5": {
            name: "Financial Indicators & Conclusions",
            details: "Automatic accounting analysis"
          },
          "6": {
            name: "Priority support",
            details: "Dedicated assistance"
          },
          "7": {
            name: "Smart Legal Prompt Generation",
            details: "AI-assisted drafting for cases"
          },
          "8": {
            name: "Followed Court Cases & Change Alerts",
            details: "Automatic monitoring of court cases and notifications for new hearings, procedural status changes, appeals, and rulings."
          },
          "9": {
            name: "Legislative Changes & Email Alerts",
            details: "Personalized alerts for monitored legal domains and email notifications for changes to monitored normative acts."
          }
        }
      },
      premium_semiannual: {
        name: "Premium - 6 Months",
        cta: "Subscribe Now",
        features: {
          "0": {
            name: "All Basic benefits",
            details: null
          },
          "1": {
            name: "Extended jurisprudence search",
            details: "Max 50 results per query"
          },
          "2": {
            name: "Predictive Legal Report (beta)",
            details: "Success rate, estimated duration & strategies"
          },
          "3": {
            name: "Grid Tests",
            details: "Automatically generated from case law"
          },
          "4": {
            name: "Stamp Duty Calculator",
            details: "Automatic calculation with AI assistant"
          },
          "5": {
            name: "Financial Indicators & Conclusions",
            details: "Automatic accounting analysis"
          },
          "6": {
            name: "Priority support",
            details: "Dedicated assistance"
          },
          "7": {
            name: "Smart Legal Prompt Generation",
            details: "AI-assisted drafting for cases"
          },
          "8": {
            name: "Followed Court Cases & Change Alerts",
            details: "Automatic monitoring of court cases and notifications for new hearings, procedural status changes, appeals, and rulings."
          },
          "9": {
            name: "Legislative Changes & Email Alerts",
            details: "Personalized alerts for monitored legal domains and email notifications for changes to monitored normative acts."
          }
        }
      },
      premium_annual: {
        name: "Premium - Annual",
        cta: "Subscribe Now",
        features: {
          "0": {
            name: "All Basic benefits",
            details: null
          },
          "1": {
            name: "Extended jurisprudence search",
            details: "Max 50 results per query"
          },
          "2": {
            name: "Predictive Legal Report (beta)",
            details: "Success rate, estimated duration & strategies"
          },
          "3": {
            name: "Grid Tests",
            details: "Automatically generated from case law"
          },
          "4": {
            name: "Stamp Duty Calculator",
            details: "Automatic calculation with AI assistant"
          },
          "5": {
            name: "Financial Indicators & Conclusions",
            details: "Automatic accounting analysis"
          },
          "6": {
            name: "Priority support",
            details: "Dedicated assistance"
          },
          "7": {
            name: "Smart Legal Prompt Generation",
            details: "AI-assisted drafting for cases"
          },
          "8": {
            name: "Followed Court Cases & Change Alerts",
            details: "Automatic monitoring of court cases and notifications for new hearings, procedural status changes, appeals, and rulings."
          },
          "9": {
            name: "Legislative Changes & Email Alerts",
            details: "Personalized alerts for monitored legal domains and email notifications for changes to monitored normative acts."
          }
        }
      }
    }
  },
  fr: {
    seo: {
      title: "Abonnements LegeaAplicata - IA Juridique Avancée et Compte",
      desc: "Choisissez le bon abonnement pour accéder aux fonctionnalités d'IA juridique avancée. Comptes pour étudiants, professionnels et institutions. Débloquez l'analyse prédictive et la recherche illimitée.",
      keywords: "compte juridique, abonnement ia juridique, étudiant ia juridique, ia juridique avancé, abonnement legea aplicata, prix ia juridique, compte avocat, compte conseiller juridique, forfaits juridiques",
      productName: "LegeaAplicata.ro IA Juridique",
      productDesc: "Plateforme avancée de recherche juridique et d'analyse IA pour les professionnels du droit en Roumanie.",
      offerBasicDesc: "Accès limité pour les visiteurs",
      offerPremiumDesc: "Accès complet aux fonctionnalités d'IA"
    },
    badgePopular: "RECOMMANDÉ",
    priceAfterRegister: "Le prix est disponible après l'inscription",
    billed: "Facturé",
    slotsRemaining: "restantes",
    details: "Détails",
    backBtn: "Retour à la Page Principale",
    faqTitle: "Questions Fréquentes",
    intervals: {
      month: "mois",
      sixMonths: "6 mois",
      year: "an",
      unlimited: "Illimité"
    },
    billingFrequency: {
      monthly: "mensuel",
      sixMonths: "tous les 6 mois",
      yearly: "annuel"
    },
    cta: {
      promoFree: "Commencer gratuitement",
      basic: "Créer un Compte Gratuit",
      premium_monthly: "S'abonner Maintenant",
      premium_semiannual: "S'abonner Maintenant",
      premium_annual: "S'abonner Maintenant"
    },
    promoBannerText1: "Les premiers {limit} utilisateurs bénéficient d'un",
    promoBannerText2: "accès GRATUIT à Premium.",
    promoLimitedOffer: "L'offre est limitée - profitez-en maintenant !",
    bottomPromoBannerTitle: "Uniquement pour les premiers {limit}.",
    bottomPromoBannerDesc: "Après avoir atteint la limite, l'abonnement sera disponible au tarif standard.",
    featuresIncludePrevious: "Tout ce qui est inclus dans {previousPlan}, plus :",
    featuresIncludeThis: "Ce plan comprend :",
    audioDaily: "Législation audio — {count} requêtes par jour",
    audioUnlimited: "Législation audio — requêtes illimitées",
    personalAudio: "Séries personnelles avec lecture audio",
    personalAudioDetails: "20 séries de 100 questions. Catégories, questions à trois choix, corrigés et commentaires. Audio généré à la sauvegarde, régénéré après modification et supprimé avec la question.",
    studyGoals: "Objectifs et statistiques",
    studyGoalsDetails: "Objectif quotidien, date d’examen et progression sur 7, 30 ou 90 jours. Réponses correctes et essais assistés.",
    audioDetails: "Un article avec son explication IA = une requête. Vitesse réglable, signets et minuterie. La pause et la reprise ne consomment aucune requête supplémentaire.",
    checkout: {
      title: "Paiement",
      cancel: "Annuler"
    },
    promoSuccess: {
      title: "Félicitations ! Votre compte est Premium.",
      desc: "Vous avez réclamé avec succès l'une des places gratuites de notre campagne promotionnelle. Vous bénéficiez d'un accès gratuit pendant 1 an à toutes les fonctionnalités de la plateforme LegeaAplicată.",
      btn: "Commencer la Recherche"
    },
    faqs: {
      q1: {
        question: "Comment fonctionnent les abonnements ?",
        answer: "Les abonnements LegeaAplicata.ro offrent un accès différencié aux ressources juridiques et aux fonctionnalités d'IA. Le plan Gratuit permet une exploration de base, tandis que les plans Premium débloquent des analyses avancées, l'assistant IA et un accès illimité à la jurisprudence."
      },
      q2: {
        question: "Puis-je annuler à tout moment ?",
        answer: "Oui, vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre compte. L'accès restera valable jusqu'à la fin de la période déjà payée."
      },
      q3: {
        question: "Existe-t-il des plans pour les étudiants ?",
        answer: "Oui, nous offrons des réductions spéciales pour les étudiants. Veuillez nous contacter avec une preuve de statut d'étudiant pour recevoir l'offre."
      },
      q4: {
        question: "Mes données sont-elles en sécurité ?",
        answer: "Absolument. Nous utilisons des mesures de sécurité conformes aux normes de l'industrie pour protéger toutes les données et transactions. Les paiements sont traités de manière sécurisée via Stripe."
      },
      q5: {
        question: "Est-ce que je reçois une facture ?",
        answer: "Oui, une facture fiscale est automatiquement émise pour chaque paiement, qui peut être téléchargée depuis votre compte client ou reçue par e-mail."
      }
    },
    plans: {
      basic: {
        name: "Basic - Gratuit",
        cta: "Créer un Compte Gratuit",
        features: {
          "0": {
            name: "Inscription gratuite",
            details: "Compte valable en permanence"
          },
          "1": {
            name: "Recherche de jurisprudence",
            details: "Accès à la base de données"
          },
          "2": {
            name: "Vues limitées",
            details: "Max 20 résultats par requête"
          },
          "3": {
            name: "Profil personnalisé",
            details: "Données personnelles sécurisées"
          },
          "4": {
            name: "Enregistrer les résultats",
            details: "Dossier virtuel pour les affaires favorites"
          },
          "5": {
            name: "Statistiques d'utilisation",
            details: "Suivi de l'activité"
          },
          "6": {
            name: "Génération de Prompt Juridique Intelligent",
            details: "Rédaction assistée par IA pour les affaires"
          },
          "7": {
            name: "Accès aux 45 fonctions & calculateurs",
            details: "Guide interactif complet et outils juridiques spécialisés"
          }
        }
      },
      premium_monthly: {
        name: "Premium - Mensuel",
        cta: "S'abonner Maintenant",
        features: {
          "0": {
            name: "Tous les avantages Basic",
            details: null
          },
          "1": {
            name: "Recherche étendue de jurisprudence",
            details: "Max 50 résultats par requête"
          },
          "2": {
            name: "Rapport Juridique Prédictif (bêta)",
            details: "Taux de réussite, durée estimée et stratégies"
          },
          "3": {
            name: "Tests sur grille",
            details: "Générés automatiquement à partir de la jurisprudence"
          },
          "4": {
            name: "Calculateur de taxe de timbre",
            details: "Calcul automatique avec assistant IA"
          },
          "5": {
            name: "Indicateurs et conclusions financières",
            details: "Analyse comptable automatique"
          },
          "6": {
            name: "Support prioritaire",
            details: "Assistance dédiée"
          },
          "7": {
            name: "Génération de Prompt Juridique Intelligent",
            details: "Rédaction assistée par IA pour les affaires"
          },
          "8": {
            name: "Dossiers judiciaires suivis & alertes de modification",
            details: "Suivi automatisé des dossiers judiciaires et notifications pour les nouvelles audiences, changements de statut, recours et décisions."
          },
          "9": {
            name: "Modifications législatives & alertes e-mail",
            details: "Alertes personnalisées pour les domaines juridiques suivis et notifications par e-mail lors de modifications des textes normatifs surveillés."
          }
        }
      },
      premium_semiannual: {
        name: "Premium - 6 Mois",
        cta: "S'abonner Maintenant",
        features: {
          "0": {
            name: "Tous les avantages Basic",
            details: null
          },
          "1": {
            name: "Recherche étendue de jurisprudence",
            details: "Max 50 résultats par requête"
          },
          "2": {
            name: "Rapport Juridique Prédictif (bêta)",
            details: "Taux de réussite, durée estimée et stratégies"
          },
          "3": {
            name: "Tests sur grille",
            details: "Générés automatiquement à partir de la jurisprudence"
          },
          "4": {
            name: "Calculateur de taxe de timbre",
            details: "Calcul automatique avec assistant IA"
          },
          "5": {
            name: "Indicateurs et conclusions financières",
            details: "Analyse comptable automatique"
          },
          "6": {
            name: "Support prioritaire",
            details: "Assistance dédiée"
          },
          "7": {
            name: "Génération de Prompt Juridique Intelligent",
            details: "Rédaction assistée par IA pour les affaires"
          },
          "8": {
            name: "Dossiers judiciaires suivis & alertes de modification",
            details: "Suivi automatisé des dossiers judiciaires et notifications pour les nouvelles audiences, changements de statut, recours et décisions."
          },
          "9": {
            name: "Modifications législatives & alertes e-mail",
            details: "Alertes personnalisées pour les domaines juridiques suivis et notifications par e-mail lors de modifications des textes normatifs surveillés."
          }
        }
      },
      premium_annual: {
        name: "Premium - Annuel",
        cta: "S'abonner Maintenant",
        features: {
          "0": {
            name: "Tous les avantages Basic",
            details: null
          },
          "1": {
            name: "Recherche étendue de jurisprudence",
            details: "Max 50 résultats par requête"
          },
          "2": {
            name: "Rapport Juridique Prédictif (bêta)",
            details: "Taux de réussite, durée estimée et stratégies"
          },
          "3": {
            name: "Tests sur grille",
            details: "Générés automatiquement à partir de la jurisprudence"
          },
          "4": {
            name: "Calculateur de taxe de timbre",
            details: "Calcul automatique avec assistant IA"
          },
          "5": {
            name: "Indicateurs et conclusions financières",
            details: "Analyse comptable automatique"
          },
          "6": {
            name: "Support prioritaire",
            details: "Assistance dédiée"
          },
          "7": {
            name: "Génération de Prompt Juridique Intelligent",
            details: "Rédaction assistée par IA pour les affaires"
          },
          "8": {
            name: "Dossiers judiciaires suivis & alertes de modification",
            details: "Suivi automatisé des dossiers judiciaires et notifications pour les nouvelles audiences, changements de statut, recours et décisions."
          },
          "9": {
            name: "Modifications législatives & alertes e-mail",
            details: "Alertes personnalisées pour les domaines juridiques suivis et notifications par e-mail lors de modifications des textes normatifs surveillés."
          }
        }
      }
    }
  }
};

export default abonamenteTranslations;
